module.exports = __webpack_public_path__ + "static/smart-kids-3ddc92b70653c4a08a980f3063dc52f9.png";